module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA0CAYAAADfRPtlAAAAlElEQVRoge3ZsQ2AIBQA0Y9hFvZfB5bRxhoxwcCZe40FhnCh+iHVWs/YS7q/U851zNhkZwbSGUhnIJ2BdAbSGUhnIF1efYCO9PxLRCmlu+4NLjQ00bfWuuu/v0ED6QykM5DOQDoD6QykM5Aux+DkvIAT/Ygcc97CZ76rv9rLiX71Ab5mIJ2BdAbSGUhnIJ2BdL8PvACHBA77O4BRvgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/1+5.png
// module id = UwW6
// module chunks = 0